export default "__VITE_ASSET__9bzGknfc__"